export default "__VITE_ASSET__Ck$KazIK__"